import { FC } from 'react';
import { Button, ButtonSizes, ButtonStyles } from '@silverfort/sf-components';

interface Props {
    isOptionSelected: boolean;
    onStatusSubmit: () => void;
    onClose: () => void;
}

const ResolutionFeedbackFooter: FC<Props> = ({ onStatusSubmit, onClose, isOptionSelected }) => {
    return (
        <div className="flex items-center justify-end gap-2">
            <Button
                buttonStyle={ButtonStyles.GhostSolid}
                buttonSize={ButtonSizes.Medium}
                text="Cancel"
                onClick={onClose}
            />
            <Button
                disabled={!isOptionSelected}
                buttonStyle={ButtonStyles.PrimarySolid}
                buttonSize={ButtonSizes.Medium}
                text="Send"
                onClick={onStatusSubmit}
            />
        </div>
    );
};

export default ResolutionFeedbackFooter;
